<template>
  <div class="user-menu">
    <!-- <h2>个人中心</h2> -->
    <div class="menu-list">
      <div v-for="(item, index) in menus" :key="index">
        <div
          @click="tab(item, index)"
          class="menu-item"
          :class="{ active: item.title === title }" :style="{marginBottom:item.children && item.children.length>0?'0' : '10px'}"
        >
          <img
            :src="item.title === title ? item.iconCurImg : item.iconImg"
            class="icon-img"
          />
          <span class="title"> {{ item.title }} </span>
        </div>
        <div v-if="item.children && item.children.length > 0" class="sub-menu">
          <ul>
            <li
              v-for="(child, ic) in item.children"
              :key="ic"
              @click="onChildClick(item, child)"
              v-if="child.neddJudgment && userInfo[child.key] || !child.neddJudgment"
              :class="[child.title === sub_title ? 'active' : '']"
            >
              {{ child.title }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "WorkBenchMenu",
  props: {},
  data() {
    return {
      title: "",
      sub_title: "",
      menus: [
        {
          name: "WorkBenchHome",
          title: "工作台",
          path: "/workbench/home",
          iconImg: require("../../assets/images/icon-workbench-new.png"),
          iconCurImg: require("../../assets/images/icon-workbench-new.png"),
        },
        {
          name: "MyCreation",
          title: "我的创作",
          iconImg: require("../../assets/images/icon-create.png"),
          iconCurImg: require("../../assets/images/icon-create.png"),
          children: [
            {
              name: "MyCreations",
              title: "我的笔记",
              path: "/workbench/creations",
              // iconImg: require('../../assets/images/icon-creations.png'),
              // iconCurImg: require('../../assets/images/icon-creations-active.png')
            },
            {
              name: "WorkBenchMyTemplate",
              title: "我的款式",
              path: "/workbench/template",
              // iconImg: require('../../assets/images/icon-template.png'),
              // iconCurImg: require('../../assets/images/icon-template-active.png')
            },
            {
              name:"MatchLog",
              title:"参赛记录",
              path:"/workbench/matchLog"
            },
            {
              name:"MyTeam",
              title:"我的团队",
              path:"/workbench/myTeam"
            }
          ],
        },
        {
          name: "MyBusiness",
          title: "业务运营",
          iconImg: require("../../assets/images/icon-business.png"),
          iconCurImg: require("../../assets/images/icon-business.png"),
          children: [
             {
              name: "PatternMakerOrder",
              title: "打版订单",
              path: "/workbench/patternMakerOrder",
              iconImg: require("../../assets/images/icon-order.png"),
              iconCurImg: require("../../assets/images/icon-order-active.png"),
              neddJudgment:true,
              key:'is_pattern_maker'
            },
            {
              name: "ProcurementOrder",
              title: "代购订单",
              path: "/workbench/procurementOrder",
              neddJudgment:true,
              key:'is_procurement'
            },
            {
              name: "OrderCenter",
              title: "样衣订单",
              path: "/order/center",
              iconImg: require("../../assets/images/icon-order.png"),
              iconCurImg: require("../../assets/images/icon-order-active.png"),
            },
            {
              name: "MallOrderCenter",
              title: "商城订单",
              path: "/order/mallcenter",
              iconImg: require("../../assets/images/icon-order.png"),
              iconCurImg: require("../../assets/images/icon-order-active.png"),
            },
            {
              name: "ShopHome",
              title: "店铺管理",
              path: "/shop/home?uid=" + this.$store.state.userInfo?.code,
              // iconImg: require('../../assets/images/icon-shop.png'),
              // iconCurImg: require('../../assets/images/icon-shop-active.png')
            },
            {
              name:"MaterialWearhouse",
              title:"面辅料库",
              path:"/workbench/materialWearhouse"
            },
            {
              name: "OpenShop",
              title: "平台商城",
              path: "/workbench/openShop",
              // iconImg: require('../../assets/images/icon-shop.png'),
              // iconCurImg: require('../../assets/images/icon-shop-active.png')
            },
            {
              name: "账户管理",
              title: "账户管理",
              path: "/workbench/userBalance",
              // iconImg: require('../../assets/images/icon-shop.png'),
              // iconCurImg: require('../../assets/images/icon-shop-active.png')
            },
          ],
        },
        {
          name: "Social",
          title: "社交互动",
          iconImg: require("../../assets/images/icon-social.png"),
          iconCurImg: require("../../assets/images/icon-social.png"),
          children: [
            {
              name: "MyFollow",
              title: "我的关注",
              path: "/workbench/fansfollow/follow",
              iconImg: require("../../assets/images/icon-myfollow.png"),
              iconCurImg: require("../../assets/images/icon-myfollow.png"),
            },
            {
              name: "MyFans",
              title: "粉丝管理",
              path: "/workbench/fansfollow/fans",
            },
            {
              name:"MyInvite",
              title:"我的邀请",
              path:"/workbench/myInvite"
            }
          ],
        },
        {
          name: "AccountManage",
          title: "账号管理",
          iconImg: require("../../assets/images/icon-account.png"),
          iconCurImg: require("../../assets/images/icon-account.png"),
          children: [
            {
              name: "UserCenter",
              title: "个人资料",
              path: "/workbench/center",
            },
            {
              name: "Address",
              title: "地址管理",
              path: "/workbench/address",
            },
            {
              name:"Agreement",
              title:"用户协议",
              path:"/workbench/agreement"
            },
            {
              name:"MallCollect",
              title:"我的收藏",
              path:"/workbench/mallCollection"
            },
          ],
        },
      ],
      height: "500px",
    };
  },
  watch: {
    $route(to) {
      let name = to.name;
      this.menus.forEach((item) => {
        if (item.name === name) {
          this.title = item.title;
        }
      });
    },
  },
  computed:{
    ...mapState({
      userInfo:state=>state.userInfo
    })
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.name === "FansFollow") {
        switch (to.params.type) {
          case "follow":
            this.title = "我的关注";
            break;
          case "fans":
            this.title = "粉丝管理";
            break;
        }
      }
    });
  },
  created() {
    this.height = window.innerHeight - 78 + "px";
    let name = this.$route.name;
    if (name === "FansFollow") {
      switch (this.$route.params.type) {
        case "follow":
          this.title = "我的关注";
          break;
        case "fans":
          this.title = "粉丝管理";
          break;
      }
    }
    const {sub_title} = this.$route.params;
    if(sub_title && sub_title === '申请开店'){
      const res = this.getParentByChildName(name);
      this.title = res.parent.title;
      this.sub_title = res.child.title;
    }else{
      this.menus.forEach((item) => {
        if (item.name === name) {
          this.title = item.title;
        }
      });
    }
    console.log("route", this.$route);
    // console.log('this.title',this.title);
  },
  methods: {
    getParentByChildName(childName) {
      console.log('childName',childName);
      if(childName === 'ShopApply'){
        childName = 'ShopHome';
      }
      for (let i = 0; i < this.menus.length; i++) {
        const parent = this.menus[i];
        if (parent.children && parent.children.length > 0) {
          for (let j = 0; j < parent.children.length; j++) {
            const child = parent.children[j];
            if (child.name === childName) {
              return {
                parent: parent,
                child: child
              };
            }
          }
        }
      }
      return null;
    },
    async onChildClick(parent, child) {
      await this.$store.dispatch('getUser');
      this.sub_title = !child ? "" : child.title;
      this.title = parent.title;
      console.log("child", child);
      if((!this.userInfo.shop_status || this.userInfo.shop_status != 1) && child.name === 'ShopHome'){
        console.log('店铺未开通');
        this.$router.push({
          name:"ShopApply",
          params:{sub_title:'申请开店'}
        })
        return;
      }
      if(child.name === 'ShopHome'){
        this.$router.push({name:'ShopManage',query:{uid:this.userInfo.code}});
        return;
      }
      this.$router.push({
        path: child.path,
        params: { sub_title: child.title },
      });
    },
    tab(e, index) {
      // if(['MyFollow','MyFans'].includes(e.name)){
      // 	this.$layer.msg('暂未开放');
      // 	return;
      // }
      switch (e.name) {
        case "MyFollow":
          this.$router.push({
            name: "MyFollow",
            params: {
              type: "follow",
            },
          });
          break;
        case "MyFans":
          this.$router.push({
            name: "MyFans",
            params: {
              type: "fans",
            },
          });
          break;
        default:
          if (!e.path) {
            this.onChildClick(e, this.menus[index].children[0]);
            return;
          }
          if (e.name === "WorkBenchHome") {
            this.sub_title = "";
          }
          this.$router.push({
            path: e.path,
          });
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.user-menu {
  width: 250px;
  background: #ffffff;
  padding-top: 40px;
  height: 100%;

  h2 {
    padding: 30px 0 24px 28px;
    color: #333;
    font-weight: bold;
  }

  .menu-list {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 80px;
    padding-bottom: 50px;
    .menu-item {
      width: 160px;
      height: 44px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      color: #68696a;
      cursor: pointer;
      .icon-img {
        width: 21px;
        height: 21px;
        margin-left: 11px;
        margin-right: 9px;
      }

      &:hover,
      &.active {
        background: #f5f5f5;
        font-size: 16px;
        color: #000000;
        border-radius: 5px;
      }
    }
    .sub-menu {
      color: #333333;
      font-size: 15px;
      ul {
        list-style-type: none;
        padding: 0;
        margin: 0;

        li {
          position: relative;
          /* 用于定位伪元素 */
          padding-left: 25px;
          margin-left: 25px;
          /* 为正方形留出空间 */
          // border-bottom: 1px solid #ddd;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
          transition: background 0.3s;
          color: #000000;
          height: 40px;
          font-size: 16px;
          line-height: 40px;
          &:last-child{
            margin-bottom:10px;
          }

          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            /* 垂直居中 */
            width: 7px;
            height: 7px;
            background-color: #b3b3b3;
            /* 黑色正方形 */
            border-radius: 2px;
            /* 可选：轻微圆角 */
            margin-left: 10px;
            margin-right: 15px;
          }

          &:hover,
          &.active {
            // background: #FA3D5A;
            color: #fa3d5a;
            font-weight: bold;
            &::before {
              background-color: #fa3d5a;
            }
          }
        }
      }
    }
  }
}
</style>
